import React, { useState } from "react";
import api from "../api/axiosConfig";
import { useNavigate } from "react-router-dom";
import "./AdminLogin.css"; // Reuse the same CSS for consistency
import {
  FiUser,
  FiLock,
  FiArrowLeft,
  FiCheck,
  FiEye,
  FiEyeOff,
  FiMail,
  FiSend,
} from "react-icons/fi"; // Import necessary icons

const UserForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleSendOtp = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    try {
      await api.post("/api/reset-password/user/request-otp", { email });
      setOtpSent(true);
      setSuccess("OTP has been sent to your email.");
    } catch (err) {
      setError(
        err.response?.data?.message ||
          "Failed to send OTP. Please check the email."
      );
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    if (!otpSent) {
      setError("Please request and enter the OTP sent to your email.");
      return;
    }
    if (!otp || otp.length < 4) {
      setError("Please enter the OTP sent to your email.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }
    try {
      await api.post("/api/reset-password/user/reset-with-otp", {
        email,
        otp,
        newPassword,
      });
      setSuccess("Password reset successfully");
      setError("");
      // Optionally navigate back to login after a delay
      setTimeout(() => navigate("/user-login"), 2000);
    } catch (err) {
      setError(err.response?.data?.message || "Failed to reset password.");
      setSuccess("");
    }
  };

  return (
    <div className="login-page-container">
      <div className="login-card">
        <div className="login-card-header">
          <h2>Reset User Password</h2>
          <p>Enter your email to receive an OTP</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label>Email</label>
            <div className="input-wrapper">
              <FiMail className="input-icon" />
              <input
                type="email"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </div>

          <div
            className="input-group"
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleSendOtp}
              disabled={!email}
            >
              <FiSend /> Send OTP
            </button>
          </div>

          {otpSent && (
            <>
              <div className="input-group">
                <label>OTP</label>
                <div className="input-wrapper">
                  <FiUser className="input-icon" />
                  <input
                    type="text"
                    className="form-control"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div className="input-group">
                <label>New Password</label>
                <div className="input-wrapper">
                  <FiLock className="input-icon" />
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    required
                  />
                  <button
                    type="button"
                    className="password-toggle-btn"
                    onClick={() => setShowPassword(!showPassword)}
                    aria-label={
                      showPassword ? "Hide password" : "Show password"
                    }
                  >
                    {showPassword ? <FiEyeOff /> : <FiEye />}
                  </button>
                </div>
              </div>

              <div className="input-group">
                <label>Confirm New Password</label>
                <div className="input-wrapper">
                  <FiLock className="input-icon" />
                  <input
                    type="password"
                    className="form-control"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                  />
                </div>
              </div>
            </>
          )}

          {error && <div className="alert alert-danger">{error}</div>}
          {success && <div className="alert alert-success">{success}</div>}

          <button
            type="submit"
            className="btn btn-primary"
            style={{ marginTop: "20px" }}
            disabled={!otpSent}
          >
            <FiCheck /> Reset Password
          </button>
        </form>

        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <button
            type="button"
            className="btn btn-link"
            onClick={() => navigate("/user-login")}
            style={{ color: "var(--text-secondary)", textDecoration: "none" }}
          >
            <FiArrowLeft /> Back to Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserForgotPassword;
